const baseUrl = document.location.protocol + '//' + document.location.host;
const apiBaseUrl = 'https://office.propcrowdy.com/api/v1/';

export {baseUrl, apiBaseUrl};
